import React from "react";
import { Row } from "react-bootstrap";
import { FaTools, FaClock, FaShieldAlt } from "react-icons/fa";

const ThreeLayer = () => {
  return (
    <section className="vendor-categories-section py-5 secondary_bg">
      <div className="container py-5">
        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center mb-5">
            <span className="works-subtitle">TrustScore</span>
            <h2 className="display-5 fw-bold mb-4">
              Advanced 3-Layer Rating System
            </h2>
            <p className="lead">
              Multi-layer feedback to maintain consistent service standards.
            </p>
          </div>
        </div>

        {/* Categories */}
        <Row className="g-4">
          {[
            {
              icon: <FaTools />,
              title: "Work Quality",
              subtitle: "Skill level, Behaviour & Customer Feedback",
            },
            {
              icon: <FaClock />,
              title: "Speed Rating",
              subtitle: "On-time arrival & Job completion time",
            },
            {
              icon: <FaShieldAlt />,
              title: "Safety & Trust",
              subtitle: "Police verification & Verified Profile badge",
            },
          ].map((item, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div className="card h-100 text-center hover-card">
                <div className="card-body">
                  <div
                    className={`icon-wrapper text-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center`}
                  >
                    {item.icon}
                  </div>
                  <h5>{item.title}</h5>
                  <span>{item.subtitle}</span>
                </div>
              </div>
            </div>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default ThreeLayer;
